import React, { Fragment } from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../UniversalComponents/SelectComponent";
import Input from "../UniversalComponents/InputComponent";
import Button from "../UniversalComponents/DefaultButton";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import { Checkbox, Dialog } from "@mui/material";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import CustomerHeaderHoc from "./CustomerHeaderHoc";
import TableComponent from "../UniversalComponents/TableComponent";

const CreditMemo = () => {
  const [memoDate, setMemoDate] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [memoValue, setMemoValue] = useState("");
  const [ccValue, setCCValue] = useState("");
  const [bccValue, setBCCEmail] = useState("");
  const [inputEmailValue, setInputEmailValue] = useState("");
  const [inputTagValue, setInputTagValue] = useState("");
  const [selected, setSelected] = useState("");
  const [isOpenEmail, setIsOpenEmail] = useState(false);

  const emailOutsideClick = useClickOutside(() => {
    setIsOpenEmail(false);
  });

  const optionData = ["Privacy", "Print or Preview", "Make Recurring"];
  const clientOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const tagOptions = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const handleTagChange = (e) => {
    setInputTagValue(e.target.value);
  };
  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputMemoChange = (e) => {
    setMemoValue(e.target.value);
  };
  const handleInputCcChange = (e) => {
    setCCValue(e.target.value);
  };
  const handleInputBCCEmailChange = (e) => {
    setBCCEmail(e.target.value);
  };
  const handleInputEmailChange = (e) => {
    setInputEmailValue(e.target.value);
  };
  const handleEmailOpen = (e) => {
    setIsOpenEmail(!isOpenEmail);
  };
  const handleEmailClose = () => {
    setIsOpenEmail(false);
  };

  const handleButtonClick = () => {
    console.log("Button clicked!");
  };
  const handleSaveButtonClick = () => {
    console.log("Save Button clicked!");
  };
  const handleDoneButtonClick = () => {
    console.log("Done Button clicked!");
  };
  const handleCancelButtonClick = () => {
    console.log("Cancel Button clicked!");
  };
  const handleSelect = (option) => {
    setSelected(option);
  };

  const onChange = (dates) => {
    if (Array.isArray(dates)) {
      const [start] = dates;
      setMemoDate(start);
    } else {
      setMemoDate(dates);
    }
  };

  const placeholderDate = "DD-MM-YYYY";
  const displayFormat = "dd-MM-yyyy";
  return (
    <form className="mx-10">
      <div className="  flex gap-3 mb-4">
        <div className="bg-white border border-[#D6D3D3] px-4 w-[90%] rounded ">
          <div className="space-x-2 flex pt-4 justify-between w-full">
            <div className="w-full">
              <label className=" text-14 text-434852 font-400 pb-1 pl-1">Client</label>
              <div>
                <Select
                  placeholder="Choose Client"
                  options={clientOptions}
                  value={selectedValue}
                  onChange={handleSelectChange}
                  style={{ width: "100%", color: "#AFAFAF", fontSize: "12px", height: "35px", padding: "5px" }}
                />
              </div>
            </div>
            <div className="w-full relative">
              <label className=" text-14 text-434852 font-400 pb-1">Email</label>
              <Input
                placeholder="Enter Email Address"
                name="myInput"
                value={inputEmailValue}
                onChange={handleInputEmailChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  marginBottom: "0rem !important",
                }}
              />
              <div className="flex justify-between">
                <span className="text-009CBF text-12 font-400 cursor-pointer" onClick={handleEmailOpen}>
                  Cc/Bcc
                </span>

                <div className="space-x-1">
                  <input
                    type="checkbox"
                    className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                    style={{ boxShadow: "none" }}
                  />

                  <span className="text-[#2C495D] text-12 ">Send Later</span>
                </div>
              </div>

              {
                <Fragment>
                  {isOpenEmail && (
                    <div
                      className="absolute w-[500px] z-[100] bg-white rounded-md  px-4  py-4 shadow-1 "
                      ref={emailOutsideClick}
                    >
                      <div className="flex justify-between items-center  pb-2 border-b-2 border-[#D9D9D9]">
                        <label className="text-434852 text-16 font-500">Add Cc/Bcc</label>
                        <ClosePopUpIcn onClick={handleEmailClose} />
                      </div>
                      <div className="my-2 space-y-2">
                        <div className="w-full">
                          <label className="flex justify-between">
                            <label className=" text-14 text-434852 font-400 pb-1">Cc</label>
                          </label>
                          <div>
                            <Input
                              name="myInput"
                              // placeholder="Enter "
                              value={ccValue}
                              onChange={handleInputCcChange}
                              style={{ width: "100%", height: "35px", padding: "5px" }}
                            />
                          </div>
                        </div>
                        <div className="w-full">
                          <label className="flex justify-between">
                            <label className=" text-14 text-434852 font-400 pb-1">Bcc</label>
                          </label>
                          <div>
                            <Input
                              name="myInput"
                              // placeholder="Enter "
                              value={bccValue}
                              onChange={handleInputBCCEmailChange}
                              style={{ width: "100%", height: "35px", padding: "5px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end">
                        <Button type="secondary" onClick={handleDoneButtonClick} style={{ height: "35px" }}>
                          Done
                        </Button>
                      </div>
                    </div>
                  )}
                </Fragment>
              }
            </div>
            <div className="w-full">
              <label className="flex justify-between">
                <label className=" text-14 text-434852 font-400 pb-1">Billing address</label>
              </label>
              <div>
                <Input
                  name="myInput"
                  placeholder="Enter Billing Address"
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{ width: "100%", height: "35px", padding: "5px" }}
                />
              </div>
            </div>
          </div>
          <div className="flex space-x-2 pt-4  w-full">
            <div className="w-full">
              <label className="w-full text-14 text-434852 font-400 pb-1 ">Credit Memo Date</label>
              <div className="w-full">
                <div className="flex items-center bg-white datePicker_container rounded">
                  <DatePicker
                    selected={memoDate}
                    onChange={onChange}
                    memoDate={memoDate}
                    placeholderText={placeholderDate}
                    datedivat={displayFormat}
                    className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                  ></DatePicker>

                  <div>
                    <CalendarWithTimeIcon></CalendarWithTimeIcon>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full">
              <label className="flex justify-between">
                <label className=" text-14 text-434852 font-400 pb-1">Credit Memo No.</label>
              </label>
              <div>
                <Input
                  type="number"
                  name="myInput"
                  placeholder="Enter Number"
                  value={memoValue}
                  onChange={handleInputMemoChange}
                  style={{ width: "100%", height: "35px", padding: "5px" }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className=" text-14 text-434852 font-400 pb-1 ">Tags</label>
              <Select
                placeholder="choose an option"
                options={tagOptions}
                value={inputTagValue}
                onChange={handleTagChange}
                style={{ width: "100%", color: "#AFAFAF", fontSize: "12px", height: "35px", padding: "5px" }}
              />
              <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Manage Tags</label>
            </div>
          </div>
          <div className="flex space-x-2  pb-4 w-full"></div>
        </div>
        <div className=" border border-[#D6D3D3]   bg-white flex justify-center items-center rounded ">
          <div className="flex flex-col items-center border bg-[#0093C1] rounded-md text-white p-1 px-8 mx-10">
            <span className="text-16 font-400 whitespace-nowrap">Amount To Credit</span>
            <div className="text-30 font-600" onClick={handleButtonClick}>
              $ 0.00
            </div>
          </div>
        </div>
      </div>
      {/*  */}

      <div className="mb-4">
        <TableComponent name="itemDetails" />
      </div>

      <div className="   border bg-white p-4 border-[#D6D3D3] ">
        <div className="flex gap-4 w-[60%]">
          <div className="w-full">
            <label className="text-434852 font-400 text-14">Message displayed on credit memo</label>
            <div className="border border-[#D6D3D3] h-28 rounded-md"></div>
          </div>
          <div className="w-full">
            <label className="text-434852 font-400 text-14">Message displayed on statement</label>
            <div className="border border-[#D6D3D3] h-28 rounded-md"></div>
          </div>
        </div>

        <div className=" flex gap-4 w-[60%] pt-2">
          <div className="w-full">
            <label className="flex justify-between">
              <label className="text-14 text-434852 font-400 pb-1 ">
                <span className="font-600">Attachments(0)</span> Maximum Size 20 MB
              </label>
            </label>
            <div className="flex items-center justify-center rounded-md border-[#DFE2E5] border h-[120px] w-[100%]">
              <div className="flex flex-col items-center">
                <label className="text-[#AFAFAF] text-12 font-400 text-center">
                  Drop files here or click to select from the device
                </label>
                <div className="text-12">Upload from this device </div>
              </div>
            </div>
            <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Show existing</label>
          </div>

          <div className="w-full mt-6 border border-[#D6D3D3] h-[120px] rounded-md">
            <div className="border-b-2 pl-2 ">
              <label className="text-434852 font-400 text-14 ">Uploaded Files</label>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full mt-4">
        <div className="border bg-[#F6FEFF] h-full w-1/4">
          <div className=" my-2 text-12">
            <div className=" border-b p-1 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Sub Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className="border-b items-center w-full text-12">
              <div className="flex flex-wrap justify-between px-4 md:px-6 items-center">
                <div className="flex flex-wrap space-y-0 md:space-y-0 md:space-x-3 w-full md:w-auto">
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "percent"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("percent")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Percent</span>
                  </div>
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "value"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("value")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Value</span>
                  </div>
                </div>

                <span className="text-[#383838] font-[500] whitespace-nowrap text-12 md:text-base">$ 123.00</span>
              </div>
            </div>

            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Shipping</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total Credit</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between py-3 items-center ">
        <div className="">
          <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul>
        </div>

        <div className="flex  space-x-2 ">
          <Button type="primary" onClick={handleCancelButtonClick} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          <Button type="secondary" onClick={handleSaveButtonClick} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </form>
  );
};

export default LayoutHOC(CustomerHeaderHoc(CreditMemo));
